// ═══════════════════════════════════════════════════════════════════════════════
// Settlement reject-reason translation display helpers
// ═══════════════════════════════════════════════════════════════════════════════

import type { SettlementTranslationMeta } from '@fdh/shared';
import { resolveTranslatedDisplayText } from './translationDisplay';

export const resolveSettlementRejectedReasonDisplay = (
  reason: string,
  translation: SettlementTranslationMeta | undefined,
  showOriginal: boolean,
): string =>
  resolveTranslatedDisplayText(reason, translation?.fields.rejectedReason, showOriginal);

export const settlementRejectedReasonHasTranslation = (
  reason: string,
  translation: SettlementTranslationMeta | undefined,
): boolean => {
  const trimmed = reason.trim();
  if (trimmed === '') {
    return false;
  }
  return Boolean(
    translation?.hasTranslation && (translation.fields.rejectedReason ?? '').trim() !== '',
  );
};
